<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'login', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('forgotPassword')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="forget-main">
        <div class="forget-info">
          <div style="padding:6%;padding-bottom: 12%;">
            <div class="forgettext">{{$t('forgotPassword')}}</div>
            <authorizedLoginModule pageTitle="authorizedForgetTitle"></authorizedLoginModule>
            <div class="line">或</div>
            <div class="login-remind" v-show="remindSuccess">
              <div class="login-remindinfo">
                <div class="login-img">
                  <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                </div>
                <div class="login-remind-text">{{$t('linkToResetYoutPasswordSend')}} {{inputEmail}} {{$t('pleaseCheckYoutEmail')}}</div>
              </div>
            </div>
            <div class="login-remind-faild" :class="{'faild': verifyFail}" v-show="passFail">
              <div class="login-remindinfo">
                <div class="login-img-faild">
                  <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                </div>
                <div class="login-remind-text-faild">{{$t('pleaseValidEmail')}}</div>
              </div>
            </div>
            <form class="el-form demo-ruleForm forget-form">
              <div style="margin-top:10px;">
                <div class="forget-name">{{$t('electronEmail')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':emailError}" ref="email" :placeholder="$t('electronEmail')">
                  </div>
                </div>
              </div>
              <div style="margin-top:40px;color: rgba(136, 134, 134, 0.9803921568627451);line-height: 22px;">{{$t('pleaseYourEmailInBox')}} {{$t('weSendYouLinkToAccessInstructions')}}</div>
              <div style="margin-top:40px;">
                <el-button  :class="{'forget_send':!forget_send_show, 'forget_send_active':forget_send_show}" @click="submitForm()" data-index="forget-button">{{$t('resetPassword')}}</el-button>
              </div>
            </form>
            <div class="forget-other">
              <div>
                <router-link :to="{name:'login', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
                  {{$t('backToSignIn')}}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { forgetPass } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import authorizedLoginModule from '@/components/login/module/authorizedLogin'

export default {
  name: 'forget',
  components: {
    publicFooter,
    publicHeader,
    authorizedLoginModule
  },
  data () {
    return {
      passFail: false,
      remindSuccess: false,
      emailError: false,
      inputEmail: '',
      verifyFail: false,
      forget_send_show: false,
      source: 'roompai',
      language: this.common.languageSet(this),
      conver: ''
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  mounted: function () {
    // 存储来源
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    // 判断是否登陆
    var token = localStorage.getItem('token')
    if (token !== null) {
      // this.$router.push({name: 'Home', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQuerys}})
    }
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    submitForm () {
      var that = this
      this.forget_send_show = true
      var email = this.$refs['email'].value
      if (email === '' || email === null) {
        this.emailError = true
      } else {
        // ^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+.([a-zA-Z]{2,4})$
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,4})$/
        if (!pattern.test(email)) {
          this.emailError = true
        } else {
          this.emailError = false
        }
      }
      if (this.emailError === false) {
        this.inputEmail = email
        // this.$router.push({name: 'login', query: { send: '1' }})

        var sessionid = this.common.sessionidGet(this)
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {
          'email': email,
          'time': time,
          'sessionid': sessionid,
          'source': this.source,
          'language': this.language,
          'conver': this.conver,
          'operation': 'forgetPass'
        }
        var data = this.common.encryptionData(dataJson, this)
        forgetPass(data).then(res => {
          if (res.flag === '200') {
            this.remindSuccess = true
            sessionStorage.setItem('emailSendTips', that.inputEmail)
            sessionStorage.removeItem('verifyEmailSendEmail')

            // this.$router.push({name: 'login', query: {'source': this.source}})
            var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'login', params: {'querys': newQuerys}})
          } else if (res.flag === '102') {
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
          } else {
            this.passFail = true
          }
        })
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'forget-button') {
        if (this.forget_send_show === true) {
          this.forget_send_show = false
        }
      }
    },
    hotelLanguage (language) {
      this.language = language
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.forget-main{background-color: rgb(255, 241, 180);width:100%;height:560px; margin:0 auto;height: 100vh;padding-top: 7%;}
.forget-info{width: 31%;min-height: 540px;margin: 0 auto;background-color: rgba(255, 255, 255, 1);border: none;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451); -webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.forgettext{font-weight: 650;font-size: 24px; height: 60px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;}
.forget-form{margin:15px 0px; color:#606266;font-size: 14px;}
.forget-form input{ margin-top:10px;}
.forget_send{width: 100%;height: 44px; font-size:16px; background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);color: #FFFFFF;margin-top:30px;}
.forget_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.forget_send_active{width: 100%;height: 44px; font-size:16px; background-color: rgb(252, 210, 5, 1)!important;box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1)!important;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724)!important;-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;border-color: rgb(252, 210, 5, 1)!important;box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;color: rgb(79,76,76)!important;margin-top:30px;}
.forget-other{ text-align:center;}
.forget-other a{ font-size:14px; color:#5392F9;text-decoration-line: none;}
.el-input.is-active .el-input__inner, .el-input__inner:focus{border-color:rgba(252,210,5,1);box-shadow:0px 0px 8px rgba(252,210,5);}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
/deep/ .el-button:focus, .el-button:hover{color:rgb(79,76,76)!important;border-color:rgb(252, 210, 5, 1)!important;background-color:rgb(252, 210, 5, 1)!important;}

.login-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.login-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}

.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text-faild{color: #F56C6C;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
@media screen and (min-width: 1001px) {
.forget-info{width: 500px;}
}
@media screen and (max-width: 1000px) {
.forget-info{width: 97%;}
}
.line {width: 100%;height: 44px;line-height: 44px;font-size: 14px;text-align: center;background-image:url(/static/img/login/line.svg);background-repeat:repeat-x;background-position: center;}
</style>



// WEBPACK FOOTER //
// src/components/login/forgetPass.vue